namespace $.$$ {
	
	$mol_style_define( $optimade_zero_search_tag, {
		
		Label: {
			padding: 0,

			Paragraph: {
				padding: {
					right: 0
				},
			},
		},

	} )
	
}
